/**
 * Issue #180 — ASR 密钥表单纯逻辑（便于单测）。
 *
 * 关键安全语义：只把「用户实际输入的非空值」放进写入请求体；空/空白字段一律
 * 省略（= 不修改），这样「替换」语义不会用空串误清掉已有密钥，也不会把占位符
 * 当作明文回传。绝不在此读取/回显任何已有密钥。
 */
import type { AsrCredentialFieldKey, WriteAsrCredentialsRequest } from './types';

export function buildAsrWriteBody(
  drafts: Partial<Record<AsrCredentialFieldKey, string>>,
  keys: AsrCredentialFieldKey[],
): WriteAsrCredentialsRequest {
  const body: WriteAsrCredentialsRequest = {};
  for (const key of keys) {
    const value = drafts[key]?.trim();
    if (value) body[key] = value;
  }
  return body;
}

/** 是否存在可提交的非空字段（用于禁用保存按钮等）。 */
export function hasWritableCredentials(
  drafts: Partial<Record<AsrCredentialFieldKey, string>>,
  keys: AsrCredentialFieldKey[],
): boolean {
  return keys.some((key) => Boolean(drafts[key]?.trim()));
}
